import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CoreModule} from '../core/core.module';
import {curationComponents, curationServices, curationUtils} from './index';
import {SharedModule} from '../shared/shared.module';
import {CurationDashboardComponent} from './components/curation-dashboard/curation-dashboard.component';
import {DynamicFormModule} from '../shared/dynamic-form/dynamic-form.module';
import {SelectButtonModule} from 'primeng/selectbutton';
import {RadioButtonModule} from 'primeng/radiobutton';
import {SharedModule as PNGShared} from 'primeng/api';
import {FormsModule} from '@angular/forms';
import {LayoutModule} from '../layout/layout.module';
import {CurationEditorHelper} from './components/curation-editor/curation-editor-helper';
import {ClickOutsideModule} from 'ng-click-outside';
import {CurationEditorAberrationDataComponent} from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-aberration-data.component';
import {CurationEditorAberrationDetailsComponent} from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-aberration-details/curation-editor-aberration-details.component';
import {CurationEditorItemComponent} from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-item/curation-editor-item.component';
import {CurationEditorSummaryComponent} from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-summary/curation-editor-summary.component';
import {CurationEditorItemsContainerComponent} from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-items-container/curation-editor-items-container.component';
import {CurationEditorClinicalSignificancesContainerComponent} from './components/curation-editor/aberration/curation-editor-aberration-data/curation-editor-clinical-significances-container/curation-editor-clinical-significances-container.component';
import {NotesModule} from '../notes/notes.module';
import {WorklistModule} from '../worklist/worklist.module';
import {CurationEditorReportComponent} from './components/curation-editor/report/curation-editor-report.component';
import {PdfJsViewerModule} from 'ng2-pdfjs-viewer';
import {CurationEditorRegimenComponent} from './components/curation-editor/regimen/curation-editor-regimen.component';
import {CurationEditorTreatmentPlanComponent} from './components/curation-editor/treatmentplan/curation-editor-treatment-plan-component';
import {CurationEditorTreatmentProtocolComponent} from './components/curation-editor/treatmentprotocol/curation-editor-treatmentprotocol.component';
import {CurationEditorClinicalTrialComponent} from './components/curation-editor/clinical-trial/curation-editor-clinical-trial.component';
import {BpmnModelerModule} from '@ispm-client/modules/bpmn-modeler';
import {CurationEditorPlacementComponent} from './components/curation-editor/placement/curation-editor-placement.component';
import {CurationPathwaysBpmnComponent} from './components/curation-editor/pathways-bpmn/curation-pathways-bpmn.component';
import {ExternalSearchDetailsComponent} from '../shared/components/external-search/external-search-details/external-search-details.component';
import {ExternalSearchComponent} from '../shared/components/external-search/external-search.component';
import {FilterModule} from '../filter/filter.module';
import {CurationEditorTableContainerComponent} from './components/curation-editor/common/curation-editor-table-container/curation-editor-table-container.component';
import {
  resolveCurationDefinition,
  resolveCurationKbDefinition,
  resolveWorkflowConfigInit
} from './curation-resolvable-exports';
import {ExportModule} from '../export/export.module';
import {TrialCurationModule} from '../trial-curation/trial-curation.module';
import {EffectsModule} from "@ngrx/effects";
import {PreviewEffects} from "@ispm/test/store/preview/preview.effects";
import {CurationItemNotFoundComponent} from './components/curation-item-not-found/curation-item-not-found.component';
import {WorkflowService} from "../workflow-config/services/workflow.service";
import {TableModule} from "primeng/table";
import {RouterModule, Routes} from '@angular/router';
import {CurationContainerComponent} from "./components/curation-common/curation-container.component";
import {NavigationConfigService} from "@ispm/navigation/services/navigationConfig.service";
import { PathwayJsonTreeConverterService} from "./services/pathway-json-tree-converter.service";

const routes: Routes = [
  {
    path: 'curation', component: CurationDashboardComponent,
    resolve:
      {
        CurationDefinition: resolveCurationDefinition
      },
  },

  {
    path: 'curation/:KB', component: CurationDashboardComponent,
    resolve: {
      CurationDefinition: resolveCurationKbDefinition
    }
  },
  {
    path: 'curation/:curationId/:workflowRequestId/:revisionId/:curationType',
    component: CurationContainerComponent,
    resolve: {
      CurationDefinition: resolveCurationDefinition,
      WorflowConfigInit: resolveWorkflowConfigInit,
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    TableModule,
    ClickOutsideModule,
    PdfJsViewerModule,
    FilterModule,
    ExportModule,
    BpmnModelerModule,
    RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'}),
    SharedModule,
    LayoutModule,
    DynamicFormModule,
    SelectButtonModule,
    PNGShared,
    WorklistModule,
    NotesModule,
    TrialCurationModule,
    RadioButtonModule,
    EffectsModule.forFeature([PreviewEffects])
  ],
  declarations: [...curationComponents,
    CurationEditorAberrationDataComponent,
    CurationEditorAberrationDetailsComponent,
    CurationEditorItemComponent,
    CurationEditorSummaryComponent,
    CurationEditorItemsContainerComponent,
    CurationEditorClinicalSignificancesContainerComponent,
    CurationEditorReportComponent,
    CurationEditorRegimenComponent,
    CurationEditorPlacementComponent,
    CurationEditorTreatmentPlanComponent,
    CurationEditorTreatmentProtocolComponent,
    CurationEditorClinicalTrialComponent,
    CurationPathwaysBpmnComponent,
    ExternalSearchDetailsComponent,
    ExternalSearchComponent,
    CurationEditorTableContainerComponent,
    CurationItemNotFoundComponent],
  exports: [CurationEditorClinicalSignificancesContainerComponent,
    CurationEditorItemsContainerComponent],
  providers: [...curationServices, curationUtils, CurationEditorHelper, WorkflowService]
})

export class CurationModule {
}
